'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSnapchat = function FaSnapchat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 25.6q0-0.5-0.5-0.6-1.5-0.3-2.7-1.3t-1.8-2.4q-0.1-0.4-0.1-0.6 0-0.3 0.4-0.5t1-0.4 0.9-0.5 0.5-0.8q0-0.4-0.4-0.7t-0.9-0.3q-0.3 0-0.7 0.2t-0.7 0.2q-0.1 0-0.3-0.1 0.1-2.1 0.1-2.5 0-1.8-0.3-2.6-0.8-1.7-2.3-2.7t-3.4-0.9q-4.5 0-6.2 3.6-0.4 0.8-0.4 2.6 0 0.4 0.2 2.5-0.1 0.1-0.4 0.1-0.2 0-0.7-0.2t-0.6-0.2q-0.5 0-0.9 0.3t-0.4 0.7q0 0.5 0.4 0.8t1 0.5 1 0.4 0.4 0.5q0 0.2-0.2 0.6-1.4 3.1-4.4 3.7-0.5 0.1-0.5 0.6 0 1.1 3.1 1.5 0 0.2 0.1 0.6t0.3 0.7 0.5 0.2q0.3 0 0.8-0.1t0.9-0.1q0.8 0 1.5 0.4t1.2 0.7 1.3 0.7 1.7 0.3q1 0 1.8-0.3t1.3-0.7 1.2-0.7 1.5-0.4q0.3 0 0.8 0.1t0.9 0.1q0.3 0 0.5-0.2t0.3-0.7 0.1-0.6q3-0.4 3-1.5z m5.7-5.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaSnapchat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/snapchat.js
// module id = 1705
// module chunks = 0